// React 
import React, { useEffect, useState } from "react";
import LoadingComponent from "./LoadingComponent";
import Navbar from "./Navbar";

// Firebase
import { useAuthState } from "react-firebase-hooks/auth";
import {
  auth,
  logout,
} from "../firebase";

// Material UI
import { Button, Stack } from '@mui/material';

// react-router-dom
import { Link, useNavigate } from "react-router-dom";

function WishList(){

	const [user, loading, error] = useAuthState(auth);
	const navigate = useNavigate();

	useEffect(()=>{
		if(loading){
			return ;
		}
		if(!user){
			navigate("/");
		}
	},[user,loading]);

	return (
		<>
			<Navbar />
			{
				user ?
				<h1>WishList Page</h1>
				: <LoadingComponent /> 

			}
		</>
	);
}

export default WishList;